export const RECENT_MENU_STORAGE_KEY = 'onlabs.recent-menu-items';
export const RECENT_MENU_LIMIT = 6;
export const RECENT_MENU_EVENT = 'onlabs:recent-menu-updated';

const RECENT_MENU_CATALOG = [
  { to: '/dashboard', label: 'Dashboard', sectionTitle: 'General' },
  { to: '/dashboard-sofia-edition', label: 'Sofia Dashboard', sectionTitle: 'General' },
  { to: '/dashboard-sofia-edition-live', label: 'Sofia Wallboard', sectionTitle: 'General' },
  { to: '/weekly-report', label: 'Weekly Report', sectionTitle: 'General' },
  { to: '/inactive-escalation', label: 'Inactive SLA', sectionTitle: 'General' },
  { to: '/simulation-results', label: 'Simulation Results', sectionTitle: 'General' },
  { to: '/simulation-Page', label: 'Simulation Page', sectionTitle: 'General' },
  { to: '/contacts', label: 'Contacts', sectionTitle: 'General' },
  { to: '/dashboardStatus', label: 'Stats', sectionTitle: 'General' },
  { to: '/devices', label: 'Devices', sectionTitle: 'Devices' },
  { to: '/pmi-devices', label: 'PMI Devices', sectionTitle: 'Devices' },
  { to: '/pmi-devicesP', label: 'PMI Devices P', sectionTitle: 'Devices' },
  { to: '/my-devices', label: 'My Devices', sectionTitle: 'Devices' },
  { to: '/locations', label: 'Locations', sectionTitle: 'Devices' },
  { to: '/pmi-locations', label: 'PMI Locations', sectionTitle: 'Devices' },
  { to: '/pmi-mapping-log', label: 'PMI Mapping Log', sectionTitle: 'Devices' },
  { to: '/ta-tal-addresses', label: 'TA&TAL Addresses', sectionTitle: 'Devices' },
  { to: '/pmi-device-logs', label: 'PMI devices logs', sectionTitle: 'Devices' },
  { to: '/campaign-previews', label: 'Campaign previews', sectionTitle: 'Campaigns' },
  { to: '/campaigns', label: 'Campaign', sectionTitle: 'Campaigns' },
  { to: '/campaignsP', label: 'Campaigns', sectionTitle: 'Campaigns' },
  { to: '/manual-campaign-assignment', label: 'Campaign Assignments', sectionTitle: 'Campaigns' },
  { to: '/schedule', label: 'Scheduled Playback', sectionTitle: 'Campaigns' },
  { to: '/campaign-device-logs', label: 'Campaign assignment logs (legacy)', sectionTitle: 'Campaigns' },
  { to: '/campaign-change-logs', label: 'Campaign change logs', sectionTitle: 'Campaigns' },
  { to: '/upload-content', label: 'Upload Content', sectionTitle: 'Content' },
  { to: '/list-files', label: 'Files', sectionTitle: 'Content' },
  { to: '/products', label: 'Products', sectionTitle: 'Content' },
  { to: '/imports', label: 'Imports', sectionTitle: 'Content' },
  { to: '/import', label: 'Import File', sectionTitle: 'Content' },
  { to: '/categories', label: 'Categories', sectionTitle: 'Content' },
  { to: '/file-edit-logs', label: 'File edit logs', sectionTitle: 'Content' },
  { to: '/proof-of-play', label: 'Proof of Play', sectionTitle: 'Content' },
  { to: '/proof-of-play-live', label: 'Proof of Play Map', sectionTitle: 'Content' },
  { to: '/instructions', label: 'Instructions', sectionTitle: 'Help' },
  { to: '/instructionsNew', label: 'Инструкции', sectionTitle: 'Help' },
  { to: '/executive-summary', label: 'Executive Summary', sectionTitle: 'Help' },
  { to: '/feedback-board', label: 'Feedback Board', sectionTitle: 'Help' },
  { to: '/field-instructions', label: 'Field Instructions', sectionTitle: 'Help' },
  { to: '/change-log', label: 'Change log', sectionTitle: 'Help' },
  { to: '/access-control', label: 'Access Control', sectionTitle: 'Settings' },
  { to: '/access-audit-logs', label: 'Audit Log', sectionTitle: 'Settings' },
  { to: '/roles-permissions', label: 'Roles & Permissions', sectionTitle: 'Settings' },
  { to: '/version-management', label: 'Version Management', sectionTitle: 'Settings' },
];

const RECENT_MENU_BY_ROUTE = new Map(RECENT_MENU_CATALOG.map((item) => [item.to, item]));

export const readRecentMenuRoutes = () => {
  if (typeof window === 'undefined') {
    return [];
  }

  try {
    const rawValue = window.localStorage.getItem(RECENT_MENU_STORAGE_KEY);
    const parsed = JSON.parse(rawValue || '[]');
    return Array.isArray(parsed) ? parsed.filter((value) => typeof value === 'string' && value.trim()) : [];
  } catch (error) {
    return [];
  }
};

export const writeRecentMenuRoutes = (routes) => {
  if (typeof window === 'undefined') {
    return;
  }

  const normalizedRoutes = (Array.isArray(routes) ? routes : []).slice(0, RECENT_MENU_LIMIT);
  window.localStorage.setItem(RECENT_MENU_STORAGE_KEY, JSON.stringify(normalizedRoutes));
  window.dispatchEvent(new CustomEvent(RECENT_MENU_EVENT, { detail: normalizedRoutes }));
};

export const getRecentMenuItems = (routes) =>
  (Array.isArray(routes) ? routes : [])
    .map((route) => RECENT_MENU_BY_ROUTE.get(route))
    .filter(Boolean)
    .slice(0, RECENT_MENU_LIMIT);
